import React, { useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip, IconButton, Popover } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
  },
  popoverPaper: {
    padding: 4,
    backgroundColor: "white",
    borderRadius: 4,
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
  },
  buttonContainer: {
    display: "flex",
  },
  confirmBtn: {
    padding: 4,
    color: "#53B3EA",
    "&:hover": {
      backgroundColor: "rgba(83, 179, 234, 0.08)",
    },
  },
  cancelBtn: {
    padding: 4,
    color: "#C4455B",
    "&:hover": {
      backgroundColor: "rgba(196, 69, 91, 0.08)",
    },
  }
}));

export default function InlineConfirm({
  onConfirm,
  onCancel,
  children,
  resources,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const triggerRef = useRef(null);

  const handleTriggerClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (onCancel) onCancel();
  };

  const handleConfirm = (e) => {
    e.stopPropagation();
    onConfirm();
    setAnchorEl(null);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
		<div className={classes.root} ref={triggerRef}>
			<div onClick={handleTriggerClick}>{children}</div>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				classes={{
					paper: classes.popoverPaper,
				}}
				style={{ zIndex: 9999 }}
			>
				<div className={classes.buttonContainer}>
					<Tooltip title={resources["Confirm"]}>
						<IconButton
							size="small"
							className={classes.confirmBtn}
							onClick={handleConfirm}
							id="confirm-popover"
						>
							<CheckIcon fontSize="small" />
						</IconButton>
					</Tooltip>
					<Tooltip title={resources["Cancel"]}>
						<IconButton
							size="small"
							className={classes.cancelBtn}
							onClick={handleCancel}
							id="cancel-popover"
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</div>
			</Popover>
		</div>
	);
}
